export default __webpack_public_path__ + "static/media/java.5ef665bf.jpg";